import {
  IEntryRecordParametersTranslator,
  IEntryRecordLabels,
  IGenericRequestParametersTranslator,
  IModificationRecordLabels,
  IModifiedRecordParametersTranslator,
  INamedEntityLabels,
  IPaginationParametersTranslator,
  IPermissionedEntityLabels,
  IProjectBasedParametersTranslator,
  ISoftDeletableFilterParametersTranslator,
  ISoftDeletableLabels,
  PropertyTranslator,
  IUniqueEntityLabels,
  IUniqueEntityParametersTranslator,
  ILockableEntityLabels,
  ILockableEntityParametersTranslator,
  ISignableEntityLabels,
  ISignableEntityParametersTranslator,
} from "../../api/GenericTranslator";
import {
  IEntryRecord,
  ICreatedRecordParameters,
  IGenericRequestParameters,
  IEntityMinimalModel,
  IModelWithIntId,
  IModificationRecord,
  IModifiedRecordParameters,
  INamedEntity,
  IPaginationParameters,
  IPermissionedEntity,
  IProjectBasedResponseModel,
  IVersionedEntity,
  IVersionedEntityParameters,
  ISoftDeletableFilterParameters,
  ISoftDeletable,
  EntityConstants,
  EntryRecordOrderBy,
  ModificationRecordOrderBy,
  GenericEntityOrderBy,
  VersionedOrderBy,
  IProjectBasedParameters,
  IUniqueEntity,
  IUniqueEntityParameters,
  ILockableEntity,
  ILockableEntityParameters,
  ISignableEntity,
  ISignableEntityParameters,
  NamedEntityOrderBy,
} from "../../api/GenericTypes";

export interface LabNotebook
  extends IModelWithIntId,
    INamedEntity,
    IPermissionedEntity,
    IEntryRecord,
    IModificationRecord,
    IProjectBasedResponseModel,
    ISoftDeletable,
    IVersionedEntity,
    IUniqueEntity,
    ILockableEntity,
    ISignableEntity {
  description: string;
}
export interface LabNotebookSuggestions extends IEntityMinimalModel<LabNotebook["id"]> {}

export const labNoteBooksConstants: EntityConstants<LabNotebook, LabNotebookFilters> = {
  resource: "lab_notebooks",
  frontendIndexRoute: "lab_notebooks",
  entitySingular: "notebook",
  entityPlural: "notebooks",
  icon: "book-open",
};

export const labNotebookFieldLabels: PropertyTranslator<LabNotebook> = {
  ...INamedEntityLabels,
  ...IPermissionedEntityLabels,
  ...IEntryRecordLabels,
  ...IModificationRecordLabels,
  ...ISoftDeletableLabels,
  ...IUniqueEntityLabels,
  ...ILockableEntityLabels,
  ...ISignableEntityLabels,
  id: "Notebook ID",
  version: "Version",
  description: "Description",
  projects: "Projects",
};

export interface LabNotebookVersion extends LabNotebook, IVersionedEntity {}

export interface LabNotebookMinimalModel extends IEntityMinimalModel {}

export type LabNotebookWriteModel = Omit<
  LabNotebook,
  "id" | "enteredBy" | "enteredOn" | "modifiedBy" | "modifiedOn" | "isDeleted" | "version"
>;

export interface LabNotebookStatistics {
  ExperimentsTotal: number;
  EntriesTotal: number;
  LinkedDatasetsTotal: number;
  linkedLabNotebookEntriesTotal: number;
  linkedLabNotebookExperimentsTotal: number;
  linkedLabNotebooksTotal: number;
  LinkedPersonsTotal: number;
  LinkedSamplesTotal: number;
  LinkedLabNotebookTemplatesTotal: number;
}

export interface LabNotebookFilters
  extends IGenericRequestParameters<LabNotebook, LabNotebookSortingOptions>,
    IPaginationParameters,
    ICreatedRecordParameters,
    IModifiedRecordParameters,
    ISoftDeletableFilterParameters,
    IProjectBasedParameters,
    IUniqueEntityParameters,
    ILockableEntityParameters,
    ISignableEntityParameters {}

export interface LabNotebookVersionFilter extends LabNotebookFilters, IVersionedEntityParameters {}

export const LabNotebookSortingOptionsConsts = [
  ...GenericEntityOrderBy,
  ...NamedEntityOrderBy,
  ...EntryRecordOrderBy,
  ...ModificationRecordOrderBy,
  ...VersionedOrderBy,
] as const;
export type LabNotebookSortingOptions = (typeof LabNotebookSortingOptionsConsts)[number];

export const LabNotebookFiltersTranslator: PropertyTranslator<LabNotebookFilters> = {
  ...IPaginationParametersTranslator,
  ...IGenericRequestParametersTranslator,
  ...IEntryRecordParametersTranslator,
  ...IModifiedRecordParametersTranslator,
  ...ISoftDeletableFilterParametersTranslator,
  ...IProjectBasedParametersTranslator,
  ...IUniqueEntityParametersTranslator,
  ...ILockableEntityParametersTranslator,
  ...ISignableEntityParametersTranslator,
};
